import { memo } from "react";
import { useRouter } from "next/router";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";

const SubServicesProcess = memo(({ title, processData, className = "" }) => {
  const router = useRouter();
  const lang = router.locale || "en";
  return (
    <section
      className={`w-full flex flex-col items-center justify-start pt-0 pb-[40px] lg:pb-[60px] px-6 sm:px-6 lg:px-20 box-border gap-6 md:gap-10 text-text-primary max-w-[1600px] mx-auto ${className}`}
    >
      {/* Heading + Arrows */}
      <h2 className=" capitalize font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] m-0">
        {title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-y-6 gap-x-6 rounded-[24px]">
        {processData?.map((project, index) => (
          <div
            key={index}
            className="bg-white rounded-[24px] w-full flex flex-col gap-4 box-border"
            style={{
              // maxWidth: "410px",
              // maxHeight: "300px",
              paddingTop: "24px",
              paddingRight: "16px",
              paddingBottom: "24px",
              paddingLeft: "16px",
              border: "1px solid #0000003D",
            }}
          >
            {/* Number */}
            <div
              style={{
                fontFamily: "DM Sans, ui-sans-serif, system-ui",
                fontWeight: 500,
                fontSize: "40px",
                lineHeight: "120%",
                letterSpacing: "0%",
                color: "#F64A62",
              }}
            >
              {String(index + 1).padStart(2, "0")}
            </div>

            {/* Title */}
            {project?.pointTitle && (
              <h3
                className="m-0 relative text-[18px] lg:text-[24px] leading-[140%] font-medium"
                dangerouslySetInnerHTML={{
                  __html: project?.pointTitle || "",
                }}
              />
            )}

            {/* Description */}
            <div
              className="text-[16px] leading-[150%] m-0 rich-text"
              dangerouslySetInnerHTML={{
                __html: addDofollowToAnchors(project?.pointDescription) || "",
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
});

export default SubServicesProcess;
